import { render } from "./natureStudyMuseum.vue?vue&type=template&id=474e801a&scoped=true"
import script from "./natureStudyMuseum.vue?vue&type=script&lang=js"
export * from "./natureStudyMuseum.vue?vue&type=script&lang=js"

import "./natureStudyMuseum.vue?vue&type=style&index=0&id=474e801a&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474e801a"]])

export default __exports__